import { useState, useEffect } from "react";
import { DataScroller } from "primereact/datascroller";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { getAllCustomerInfo } from "../../service/allCustomerInfo.service";
import React from "react";
import LoadingSpinner from "../loading-spinner/loading-spinner";
import { Days, getPromoDays, goTo } from "../../utilities/common.utilities";
import ImageWithErrorHandling from "../Shared/ImageWithErrorHandling/imageWithErrorHandling.component";
import { useConnectivity } from "../../context/connectivityContext";
import "./events.css"

interface Event {
  categoryId: number;
  description: string;
  everyFriday: boolean;
  everyMonday: boolean;
  everySaturday: boolean;
  everySunday: boolean;
  everyThursday: boolean;
  everyTuesday: boolean;
  everyWednesday: boolean;
  fromDate: string;
  id: number;
  name: string;
  picture: string;
  rating: number;
  toDate: string;
}

export default function EventsComponent() {
  const location = useLocation();

  // Se non sono presenti dati in location.state, reindirizzo in home al posto
  // di far andare in errore il componente
  if(!location.state) {
    goTo('/home');
  }
  
  const { cardData } = location.state;
  const [events, setEvents] = useState<Event[]>([]);

  // Variabile utilizzata per sapere se ci sono errori nella ricezione degli eventi come l' assenza di connessione.
  // Utilizzata per distinguere sul template, se la mancanza di eventi è dovuta ad errore oppure effettivamente non c'è ne sono.
  const [errorGetEvents, setErrorGetEvents] = useState<boolean>(false);
  const { isOnline } = useConnectivity();


  const promoDays = (data: Event) => {
    const PromoEvent: Days = {
      monday: data.everyMonday,
      tuesday: data.everyTuesday,
      wednesday: data.everyWednesday,
      thursday: data.everyThursday,
      friday: data.everyFriday ,
      saturday: data.everySaturday,
      sunday: data.everySunday
    }

    return getPromoDays(PromoEvent)
  }

  const getEvents = () => {
    getAllCustomerInfo(cardData.groupCode, cardData.storeCode, cardData.selectedCard).then(allCustomerInfo => {
      let result: Event[] = [];
      setErrorGetEvents(false);

      if(!allCustomerInfo) {
        result = [];
        setErrorGetEvents(true);
      }
      else if(allCustomerInfo?.events?.items?.length > 0){
        result = allCustomerInfo.events.items;
      } 
      else {
        result = [];
      }

      if(result.length > 0){
        setEvents(result);
      } else {
        setEvents([]);
    }

    })
  };

  useEffect(() => {
    getEvents();
  }, [isOnline]);  // Indico di reindirizzare il componente quando la variabile isOnline cambia valore


  const itemTemplate = (data: Event) => {
    return (

      <div
        className="col-12 bg-white mt-4 p-0 custom-card events-component-style">
        <div className="flex flex-column">
          <ImageWithErrorHandling
            src={
              data.picture
                ? process.env.REACT_APP_STORAGE_URL+`/groups/` +
                  cardData.groupCode +
                  `/events/` +
                  data.id +
                  `/` +
                  data.picture
                : "EXPERIENCE_APP_ICONE_eventi.png"
            }
            style={{ borderRadius: "8px 8px 0 0"}}
            alt={data.name}
            classes="border-events-img"
          />

          <div className="p-2 pt-0 pb-0">
            <div className="flex overflow-hidden">
              <div className="flex-grow-1 flex align-items-start justify-content-start">
                <h2 className="mt-2 mb-0">{data.name}</h2>
              </div>
              {/* <div className="flex-none flex align-items-start justify-content-end mt-2 mb-0">
                <i className={data.rating ? 'pi pi-thumbs-up-fill bg-white text-primary border-0' : 'pi pi-thumbs-up bg-white text-primary border-0' } style={{fontSize: '1.5rem'}}></i>
              </div> */}
            </div>

            <div className="block mt-2">
              <div
                className="text-justify"
                dangerouslySetInnerHTML={{ __html: data.description }}
              ></div>
            </div>

            <div className="flex-grow-1 flex align-items-start justify-content-start p-1">
              <div style={{ color: "green" }}>
                <div className="flex flex-row flex-wrap">
                  <div className="flex align-items-end justify-content-start ">
                    <div
                      className="text-left font-bold from-to-style"
                      style={{ fontSize: "10px" }}
                    >
                      DAL
                    </div>
                    <div className=" ml-2 text-left font-bold">
                      {moment(data.fromDate).format("DD/MM/YYYY")}
                    </div>
                    <div
                      style={{ fontSize: "10px" }}
                      className="ml-2 text-right font-bold from-to-style"
                    >
                      AL
                    </div>
                    <div className="ml-2 text-left font-bold">
                      {moment(data.toDate).format("DD/MM/YYYY")}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-grow-1 flex align-items-center justify-content-start p-1 font-bold valid-days " style={{ color: "green"}}>
              <div dangerouslySetInnerHTML={{ __html:promoDays(data) }}>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (  
                <div>
                  <div className="flex justify-content-center">
                    <h2 className="mb-0 mt-2">Eventi</h2>
                </div>
                  <DataScroller
                    value={events}
                    itemTemplate={itemTemplate}
                    rows={100}
                    buffer={0.4}
                    header=""
                    emptyMessage={
                      <div className='text-center text-lg mt-5'>
                      
                        {
                          errorGetEvents
                          ?
                          <div className="flex flex-column">

                            {
                              isOnline
                              ?
                              <></>
                              :
                              <div className='mb-3'>
                                <img src="./offline_globe.svg" alt="" className="img-offline-globe-empty-result"></img>
                              </div>
                            }

                            <div>Impossibile caricare gli Eventi.</div>
                            {
                                navigator.onLine
                                ?
                                <></>
                                :
                                <div>Verifica la connessione internet.</div>
                            }
                          </div>
                          :
                          <div className="nothing-find">Nessun Evento trovato</div>
                        }

                      </div> 
                      }/>
                </div>
  );
}
